import { render, staticRenderFns } from "./indexText.vue?vue&type=template&id=21256293&scoped=true"
import script from "./indexText.vue?vue&type=script&lang=js"
export * from "./indexText.vue?vue&type=script&lang=js"
import style0 from "./indexText.vue?vue&type=style&index=0&id=21256293&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21256293",
  null
  
)

export default component.exports